import React, { Suspense } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import styled from 'styled-components';
import MailTockLoader from 'design-system-components/MailTockLoader/MailTockLoader';

const ForgotPasswordCode = React.lazy(
  async () => await import('../pages/Auth/ForgotPassword/ForgotPasswordCode')
);
const ForgotPasswordEnterEmail = React.lazy(
  async () =>
    await import('../pages/Auth/ForgotPassword/ForgotPasswordEnterEmail')
);
const EnterNewPassword = React.lazy(
  async () =>
    await import('../pages/Auth/ForgotPassword/ForgotPasswordEnterNewPassword')
);
const Login = React.lazy(async () => await import('../pages/Auth/Login/Login'));
const SignUpCode = React.lazy(
  async () => await import('../pages/Auth/SignUp/SignUpCode')
);
const SignUpCompanyInfo = React.lazy(
  async () => await import('../pages/Auth/SignUp/SignUpCompanyInfo')
);
const SignUpPersonalInfo = React.lazy(
  async () => await import('../pages/Auth/SignUp/SignUpPersonalInfo')
);
const Dashboard = React.lazy(async () => await import('../pages/Dashboard'));

const ForgotPasswordSuccess = React.lazy(
  async () => await import('../pages/Auth/ForgotPassword/ForgotPasswordSuccess')
);

const Error = React.lazy(async () => await import('../pages/Error/Error'));

const NotFound = React.lazy(
  async () => await import('../pages/NotFound/NotFound')
);

const NotAuthPrivacyPolicy = React.lazy(
  async () => await import('../pages/NotAuthPrivacyPolicy/NotAuthPrivacyPolicy')
);

const NotAuthRefundPolicy = React.lazy(
  async () => await import('../pages/NotAuthRefundPolicy/NotAuthRefundPolicy')
);

const NotAuthTermsAndConditions = React.lazy(
  async () =>
    await import('../pages/NotAuthTermsAndConditions/NotAuthTermsAndConditions')
);

const AppRoutes: React.FC = () => (
  <Router>
    <Suspense
      fallback={
        <LoaderContainer>
          <MailTockLoader />
        </LoaderContainer>
      }
    >
      <Routes>
        <Route path="/" element={<Login />} />

        <Route path="/login" element={<Login />} />

        <Route path="/sign-up/personal-info" element={<SignUpPersonalInfo />} />

        <Route path="/sign-up/company-info" element={<SignUpCompanyInfo />} />

        <Route path="/sign-up/verify" element={<SignUpCode />} />

        <Route
          path="/forget-password/enter-email"
          element={<ForgotPasswordEnterEmail />}
        />

        <Route
          path="/forget-password/verify"
          element={<ForgotPasswordCode />}
        />

        <Route
          path="/forget-password/reset-password"
          element={<EnterNewPassword />}
        />

        <Route
          path="/forget-password/reset-password-success"
          element={<ForgotPasswordSuccess />}
        />

        <Route path="/privacy-policy" element={<NotAuthPrivacyPolicy />} />
        <Route path="/refund-policy" element={<NotAuthRefundPolicy />} />
        <Route
          path="/terms-and-conditions"
          element={<NotAuthTermsAndConditions />}
        />

        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard/*" element={<Dashboard />} />
          <Route path="/profile" element={<Dashboard />} />
        </Route>
        <Route path="/error" element={<Error />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </Router>
);

const LoaderContainer = styled.div`
  width: 100vw;
  height: 100vh;
`;

export default AppRoutes;
